import {
    useEffect,
    useContext
} from 'react';
import { useNavigate } from 'react-router-dom';

// Context
import { AuthContext } from '@providers/Auth';

// Components
import { getLoginProvider, logout } from '@helpers/utils';
import { LoginProviders } from '@helpers/enums';
import Loader from '@components/Loader';

// Utils
import { getToken } from '@helpers/utils';

// Styles
import './LogoutCallback.scss';

const LogoutCallback = () => {
    let navigate = useNavigate();

    const { setIsLoggedIn } = useContext(AuthContext);

    const isLoginAzureADEnabled = (process.env.REACT_APP_LOGIN_AZURE_AD_ENABLED && process.env.REACT_APP_LOGIN_AZURE_AD_ENABLED.toLowerCase() === "true") || false;

    useEffect(() => {
        if (!isLoginAzureADEnabled) {
            navigate('/');
        }
        else {
            const loginProvider = getLoginProvider();

            // Check if it's redirected from microsoft otherwise redirect it back to /
            if (document.referrer !== "" && document.referrer !== window.location.host && loginProvider === LoginProviders.AzureAD) {
                const token = getToken();
                if (!token) {
                    setIsLoggedIn(false);
                    navigate('/');
                }
                else {
                    logout();
                }
            }
            else {
                navigate('/');
            }
        }
    }, [isLoginAzureADEnabled, navigate, setIsLoggedIn]);

    return (
        <div className="logout-callback__loader">
            <Loader active={true} />
        </div>
    );
};

export default LogoutCallback;